import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideTrash2 } from '@lucide/angular';

@Component({
  selector: 'ptl-v3-filter-shell',
  templateUrl: './v3-filter-shell.component.html',
  styleUrls: ['./v3-filter-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V3FilterShellComponent {
  @Input() title: string;

  @Output() applied = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<void>();

  protected readonly LucideTrash2 = LucideTrash2;
}
